import { Link } from 'react-router-dom';
import Logo from '../shared/Logo';

/**
 * AuthLayout - Modern Sleek Design System
 *
 * Centered card layout for authentication pages.
 * Midnight background with mesh gradient, cream card.
 */
export default function AuthLayout({
  children,
  title,
  subtitle,
  showBackLink = false,
  backLinkTo = '/auth/login',
  backLinkText = 'Back to login'
}) {
  return (
    <div className="min-h-screen bg-midnight bg-mesh-dark flex flex-col justify-center py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <Link to="/" className="flex justify-center">
          <Logo size="lg" />
        </Link>

        {/* Title */}
        {title && (
          <h1 className="mt-4 sm:mt-6 text-center text-2xl sm:text-3xl font-bold text-cream">
            {title}
          </h1>
        )}

        {/* Subtitle */}
        {subtitle && (
          <p className="mt-1 sm:mt-2 text-center text-sm text-cream/60">
            {subtitle}
          </p>
        )}
      </div>

      <div className="mt-6 sm:mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-cream py-6 px-4 shadow-lg rounded-xl sm:py-8 sm:px-10">
          {children}
        </div>

        {/* Back link */}
        {showBackLink && (
          <p className="mt-4 text-center text-sm text-cream/60">
            <Link
              to={backLinkTo}
              className="font-medium text-primary hover:text-primary-light transition-colors"
            >
              {backLinkText}
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
